module.exports = __webpack_public_path__ + "img/jersey.6709730b.svg";